/**
 * Renders member, provider and eligibility meta data
 * along with chart and project numbers.
 *
 * Used by Chart edit and DRG Adds edit screens.
 */
import Marionette from "backbone.marionette";
import ReviewNumberView from "./review-number";
import ProjectNameView from "./project-name";
import MemberView from "./member";
import EligibilityView from "./member-eligibility";
import CategoriesView from "./member-categories";
import ProviderView from "./provider";
import templates from "../../../utils/templates";

import "../../../../../sass/card.scss";

const DEFAULTS = {
  template: templates.find("chart_reviews", "chart_edit_meta"),
};

class View extends Marionette.LayoutView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  regions() {
    return {
      number: ".meta-review-number",
      projectName: ".meta-project-name",
      member: ".meta-member",
      eligibility: ".meta-eligibility",
      provider: ".meta-provider",
      categories: ".meta-categories",
    };
  }

  onBeforeShow() {
    this.number.show(
      new ReviewNumberView({
        model: this.model,
      })
    );

    this.projectName.show(
      new ProjectNameView({
        model: this.model,
      })
    );

    this.member.show(
      new MemberView({
        model: this.model,
      })
    );

    this.provider.show(
      new ProviderView({
        model: this.model,
      })
    );

    this.eligibility.show(
      new EligibilityView({
        model: this.model,
      })
    );

    this.categories.show(
      new CategoriesView({
        model: this.options.memberCategories,
      })
    );
  }
}

export { View as default };
